export function removeUndefined<T>(src: T): T {
    let newObject = {}
    Object.entries(src).forEach(([k, v]) => {
        if (v !== undefined) {
            //@ts-ignore
            newObject[k] = v
        }
    })
    return newObject as T
}
